import React, { useEffect, useState } from "react";
import { useLazyQuery } from "@apollo/client";
import { PUBLICATION_QUERY } from "./graphql/queries/publicationQuery";
import { BASE_GRAPHQL_ENDPOINT } from "./graphql/client";
import { useDateRange } from "./utils/hooks/LoadingHook";

type QueryingProps = {
    publicationId: number;
    publication: (publication: any) => void;
}

export const Querying = ({ publicationId, publication }: QueryingProps) => {
	const { previousWeek, today, loaded } = useDateRange(publicationId);
	const [added, setAdded] = useState(false);
	const [sendQuery, { data, loading, error }] = useLazyQuery(PUBLICATION_QUERY, {
		context: {
			uri: `${BASE_GRAPHQL_ENDPOINT}?publicationId=${publicationId}`
		},
		variables: {
			publicationId: publicationId,
			params1: {
				timeframe: {
					begin: previousWeek,
					end: today
				}
			}
		},
	});

	useEffect(() => {
		if (loaded)
			sendQuery();
	}, [loaded]);

	useEffect(() => {
		if (!loading && !added && !error && data && data.Publication) {
			push(data);
			// Prevents pushing multiple times
			setAdded(true);
		}
	}, [data, loading, error]);

	if (loading)
		return <></>;

	if (error)
		return <>{error}</>;

	const push = (requiredData: any) => {
		publication(requiredData);
	};

	return (
		<>
		</>
	);
};

export default Querying;